module.exports = __webpack_public_path__ + "fonts/YujiMai-Regular.59a6f9b2.ttf";